import React from "react";
import { Box, Typography } from "@mui/material";
import { Work } from "../../../types/work";
import WorkTable from "../../../components/tables/WorkTable";
import { SystemLanguages } from "../../../shared/enums/shared-enums";

interface TranslationSectionProps {
  work: Work;
}

const TranslationSection: React.FC<TranslationSectionProps> = ({ work }) => {
  return (
    <Box sx={{ width: "100%", mb: 4 }}>
      <Typography variant="h2" gutterBottom>
        Work Translations
      </Typography>
      <WorkTable
        enableRowActions={false}
        // Every row is a translation of this work; the column would repeat it.
        hiddenColumnIds={["translation_of_indic_work"]}
        filters={{
          system_language_type: SystemLanguages.tibetan,
          translation_of_indic_work_id: work._key,
        }}
      />
    </Box>
  );
};

export default TranslationSection;
